<template>
  <div
    class="collection-hero"
    :class="{'has-image': validImage || video}"
  >
    <div class="grid mx-m mx-l-desktop">
      <div
        class="col xs-span"
        :class="description ? 'l7' : 'l12'"
      >
        <h1
          class="text-heading-2xl text-heading-3xl-desktop"
          v-text="title"
        />
        <div
            v-if="collectiondescription"
          >
            <div
              class="collection-hero__description text-body-xl-regular-desktop mt-5xl"
              v-html="collectiondescription"
            />
        </div>
      </div>
      <div
        v-if="description"
        class="col xs-span l5"
      >
        <div
          class="collection-hero__description text-body-xl-regular-desktop"
          v-html="description"
        />
      </div>
    </div>
     
    
    <div
      v-if="validImage || video"
      class="collection-hero__media"
    >
      <responsive-video
        v-if="video"
        ref="video"
        :video-src="videoSource"
        :lazyload="false"
        autoplay-enabled
        :padding="false"
      />
      <responsive-image
        v-else
        :image="image"
        :padding="false"
        :lazyload="false"
      />
    </div>
  </div>
</template>

<script>

/**
 * Vue: Collection hero (collection-hero)
 * -----------------------------------------------------------------------------
 * Collection hero section on PLPs and search pages.
 *
 */

import { mapState } from 'vuex'
import ResponsiveImage from '~global/images/responsive-image'
import ResponsiveVideo from '~global/responsive-video/responsive-video'
import { loadVideoIosFix } from '~/helpers/vue'

export default {
  name: 'CollectionHero',
  components: {
    ResponsiveImage,
    ResponsiveVideo,
  },

  props: {

    description: {
      type: String,
      default: null,
    },
    image: {
      type: [Boolean, Object],
      default: false,
    },
    title: {
      type: String,
      default: null,
    },
    video: {
      type: [Boolean, Object],
      default: false,
    },
    collectiondescription:{
      type: String,
      default: null,
    },
  },

  data() {
    return {

    }
  },

  computed: {

    /**
     * Map Vuex state.
     */
    ...mapState({
      isMobile: (state) => state.index.screen.mobile,
    }),

    videoSource() {
      if (!this.video) {
        return ''
      }

      const videos = this.video.sources.filter((video) => video.format === 'mp4' && video.width > 1080)
      return videos[0].url
    },

    validImage() {
      if (typeof this.image !== 'object') {
        return this.image
      }

      return Object.keys(this.image).length > 0
    },
  },

  mounted() {
    // Not empty
    loadVideoIosFix(this.$refs.video)
  },

  methods: {
    // Not empty
  },
}
</script>

<style lang="scss">
@import './collection-hero';
</style>
